import TestVue from "@/views/TestView.vue";

const test = [
  {
    path: "/test",
    name: "test",
    component: TestVue,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default test;
